import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  useContext,
  useState,
  useEffect,
} from 'react';
import {
  Box,
  Button,
  TextField,
  FormControl,
  Typography,
  Dialog,
} from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import ColorLensIcon from '@material-ui/icons/ColorLens';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { SketchPicker } from 'react-color';
import TitleML from '../TitleML/TitleML';
import { StepsThreeMLStyled, ModalStyled } from './StepsThreeMLStyles';
import { Context } from '../../AddActivity';
import { UploadImageCom, SelectFieldCom } from '../FormType';
import { uploadFile } from '@/utils/uploadImg';
import ModalML from '@/components/ModalML';

function SimpleDialog(props) {
  const { onClose, selectedValue, open, imgSrc } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <img alt="" src={imgSrc} />
    </Dialog>
  );
}
const fontSizeList = [
  { name: '12', value: 12 },
  { name: '14', value: 14 },
  { name: '16', value: 16 },
  { name: '18', value: 18 },
  { name: '20', value: 20 },
];
export default forwardRef(
  ({ onSubmitSuccess, defaultValues, queryType }, fRef) => {
    const { handleSubmit, control, setValue, errors, getValues } = useForm();
    const { ref } = useContext(Context);
    const pieWrapRef = useRef();
    const [images1, setImages1] = useState();
    const [images2, setImages2] = useState();
    const [images3, setImages3] = useState();
    const [openColorModal, setOpenColorModal] = useState(false);
    const [inputName, setInputName] = useState();
    const [color, setColor] = useState('');
    const [dOpen, setDOpen] = useState(false);
    const [previewImages, setPreviewImages] = useState([]);
    const [changeNum, setChangeNum] = useState(0);
    const submitRef = useRef(null);
    const clickInputRef = () => {
      submitRef.current.click();
    };
    useImperativeHandle(ref, () => ({
      // handleSubmit 就是暴露给父组件的方法
      clickInput: clickInputRef,
    }));

    useEffect(() => {
      for (let key in defaultValues) {
        setValue(key, defaultValues[key]);
      }
      if (
        defaultValues.backgroundPic &&
        (defaultValues.backgroundPic.indexOf('http') > -1 ||
          defaultValues.backgroundPic.indexOf('https') > -1)
      ) {
        const imgUrl1 = defaultValues.backgroundPic
          ? defaultValues.backgroundPic.split('/')
          : [];
        imgUrl1.length > 0 &&
          setValue(
            'backgroundPic',
            `${imgUrl1[imgUrl1.length - 2]}/${imgUrl1[imgUrl1.length - 1]}`,
          );
      }
      if (
        defaultValues.wheelPic &&
        (defaultValues.wheelPic.indexOf('http') > -1 ||
          defaultValues.wheelPic.indexOf('https') > -1)
      ) {
        const imgUrl2 = defaultValues.wheelPic
          ? defaultValues.wheelPic.split('/')
          : [];
        imgUrl2.length > 0 &&
          setValue(
            'wheelPic',
            `${imgUrl2[imgUrl2.length - 2]}/${imgUrl2[imgUrl2.length - 1]}`,
          );
      }
      if (
        defaultValues.wheelBackgroundPic &&
        (defaultValues.wheelBackgroundPic.indexOf('http') > -1 ||
          defaultValues.wheelBackgroundPic.indexOf('https') > -1)
      ) {
        const imgUrl3 = defaultValues.wheelBackgroundPic
          ? defaultValues.wheelBackgroundPic.split('/')
          : [];
        imgUrl3.length > 0 &&
          setValue(
            'wheelBackgroundPic',
            `${imgUrl3[imgUrl3.length - 2]}/${imgUrl3[imgUrl3.length - 1]}`,
          );
      }
      let imgs = [];
      if (
        defaultValues.backgroundPic &&
        (defaultValues.backgroundPic.indexOf('http') > -1 ||
          defaultValues.backgroundPic.indexOf('https') > -1)
      ) {
        setImages1([{ data_url: defaultValues.backgroundPic }]);
        imgs.push({ data_url: defaultValues.backgroundPic });
      }
      if (
        defaultValues.wheelPic &&
        (defaultValues.wheelPic.indexOf('http') > -1 ||
          defaultValues.wheelPic.indexOf('https') > -1)
      ) {
        setImages2([{ data_url: defaultValues.wheelPic }]);
        imgs.push({ data_url: defaultValues.wheelPic });
      }
      if (
        defaultValues.wheelBackgroundPic &&
        (defaultValues.wheelBackgroundPic.indexOf('http') > -1 ||
          defaultValues.wheelBackgroundPic.indexOf('https') > -1)
      ) {
        setImages3([{ data_url: defaultValues.wheelBackgroundPic }]);
        imgs.push({ data_url: defaultValues.wheelBackgroundPic });
      }
      setPreviewImages(imgs);
    }, [defaultValues, setValue]);

    const resetStyle = (key1, key2) => {
      setValue(key1, 14);
      setValue(key2, '#000000');
      setChangeNum(changeNum + 1);
    };
    const handlePreview = (data) => {
      setPreviewImages(data);
      setDOpen(true);
    };
    const handleClose = () => {
      setDOpen(false);
    };

    const handleSetImages1 = (imgData) => {
      const file =
        Array.isArray(imgData) && imgData.length > 0 ? imgData[0].file : '';
      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('isFixedName', false);
        formData.append('isPublic', false);
        formData.append('bucket', 'GIFT-IMAGE');
        uploadFile('/common/upload', formData, (res) => {
          if (res.code === 0) {
            const url = res.data.url;
            setValue('backgroundPic', url, {
              shouldValidate: true,
            });
            setImages1(imgData);
          }
        });
      }
    };

    const handleSetImages2 = (imgData) => {
      const file =
        Array.isArray(imgData) && imgData.length > 0 ? imgData[0].file : '';
      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('isFixedName', false);
        formData.append('isPublic', false);
        formData.append('bucket', 'GIFT-IMAGE');
        uploadFile('/common/upload', formData, (res) => {
          if (res.code === 0) {
            const url = res.data.url;
            setValue('wheelPic', url, {
              shouldValidate: true,
            });
            setImages2(imgData);
          }
        });
      }
    };

    const handleSetImages3 = (imgData) => {
      const file =
        Array.isArray(imgData) && imgData.length > 0 ? imgData[0].file : '';
      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('isFixedName', false);
        formData.append('isPublic', false);
        formData.append('bucket', 'GIFT-IMAGE');
        uploadFile('/common/upload', formData, (res) => {
          if (res.code === 0) {
            const url = res.data.url;
            setValue('wheelBackgroundPic', url, {
              shouldValidate: true,
            });
            setImages3(imgData);
          }
        });
      }
    };

    return (
      <StepsThreeMLStyled>
        <Box className="step-one-wrap" ref={fRef}>
          <form onSubmit={handleSubmit(onSubmitSuccess)}>
            <Box display="flex" justifyContent="space-between" gap="0 60px">
              {/*left*/}
              <Box flex="1">
                <TitleML title="基础设置" fontSize="19px" p="32px 0" />
                <Box>
                  <Box display="flex" justifyContent="space-between">
                    <Box sx={{ width: '120px' }}>
                      <UploadImageCom
                        uW="120"
                        uH="120"
                        iW="120"
                        iH="120"
                        handleSetImages={handleSetImages1}
                        images={images1}
                        label="背景图片设定"
                        tips="建议尺寸750px*484px"
                        required={true}
                        handlePreview={handlePreview}
                        queryType={queryType}
                      />
                      {errors.backgroundPic && (
                        <Box mt={1}>
                          <Box className="input-error-style">图片必须上传</Box>
                        </Box>
                      )}
                    </Box>
                    <Box sx={{ width: '120px' }}>
                      <UploadImageCom
                        uW="120"
                        uH="120"
                        iW="120"
                        iH="120"
                        handleSetImages={handleSetImages2}
                        images={images2}
                        label="转盘图片设定"
                        tips="建议尺寸600px*600px"
                        required={true}
                        handlePreview={handlePreview}
                        queryType={queryType}
                      />
                      {errors.wheelPic && (
                        <Box mt={1}>
                          <Box className="input-error-style">图片必须上传</Box>
                        </Box>
                      )}
                    </Box>
                    <Box sx={{ width: '120px' }}>
                      <UploadImageCom
                        uW="120"
                        uH="120"
                        iW="120"
                        iH="120"
                        handleSetImages={handleSetImages3}
                        images={images3}
                        label="转盘背景图片设定"
                        tips="建议尺寸740px*740px"
                        required={true}
                        handlePreview={handlePreview}
                        queryType={queryType}
                      />
                      {errors.wheelBackgroundPic && (
                        <Box mt={1}>
                          <Box className="input-error-style">图片必须上传</Box>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
                <TitleML title="文字设置" fontSize="19px" p="32px 0" />
                <Box>
                  <Box mb={2} color="#212100" fontSize="12px">
                    活动名称文字设置
                  </Box>
                  <Box className="set-color-font-wrap">
                    <Box display="flex" gap="0 42px" alignItems="center">
                      <Box display="flex" gap="0 14px">
                        <Box display="flex">
                          <label
                            style={{
                              width: '39px',
                              lineHeight: '24px',
                              height: '24px',
                              color: 'rgba(0, 0, 0, 0.87)',
                            }}
                          >
                            字号
                          </label>
                          <FormControl
                            variant="standard"
                            sx={{ width: '70px' }}
                          >
                            <Controller
                              render={(pr) => (
                                <SelectFieldCom
                                  pr={pr}
                                  typeList={fontSizeList}
                                  queryType={queryType}
                                />
                              )}
                              label=""
                              name="activityFontSize"
                              variant="standard"
                              control={control}
                            />
                          </FormControl>
                        </Box>
                        <Box display="flex">
                          <label
                            style={{
                              width: '39px',
                              lineHeight: '24px',
                              height: '24px',
                              color: 'rgba(0, 0, 0, 0.87)',
                            }}
                          >
                            颜色
                          </label>
                          <Box
                            sx={{
                              width: '100px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
                            }}
                          >
                            <Typography
                              sx={{
                                color: getValues('activityFontColor'),
                                lineHeight: '24px',
                                height: '24px',
                              }}
                            >
                              演示
                            </Typography>
                            <span
                              className="color-range"
                              onClick={() => {
                                queryType !== 'detail' &&
                                  setOpenColorModal(true);
                                queryType !== 'detail' &&
                                  setInputName('activityFontColor');
                              }}
                              style={{ lineHeight: '24px', height: '24px' }}
                            >
                              <span
                                className="circle"
                                style={{
                                  borderColor: getValues('activityFontColor'),
                                }}
                              >
                                <ColorLensIcon
                                  style={{
                                    color: getValues('activityFontColor'),
                                  }}
                                />
                              </span>
                            </span>
                          </Box>
                          <Controller
                            render={(pr) => (
                              <TextField
                                sx={{ display: 'none' }}
                                variant="standard"
                                id="outlined-multiline-static"
                                autoComplete="off"
                                label=""
                                value={pr.value ?? ''}
                              />
                            )}
                            control={control}
                            name="activityFontColor"
                          />
                        </Box>
                      </Box>
                      {queryType !== 'detail' && (
                        <Box
                          sx={{
                            fontWeight: 400,
                            fontSize: 16,
                            color: '#1565C0',
                            width: '86px',
                            textAlign: 'center',
                            cursor: 'pointer',
                          }}
                          onClick={() =>
                            resetStyle('activityFontSize', 'activityFontColor')
                          }
                        >
                          恢复默认
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box mb={2} mt={3} color="#212100" fontSize="12px">
                    可抽奖次数文字设置
                  </Box>
                  <Box className="set-color-font-wrap">
                    <Box display="flex" gap="0 42px" alignItems="center">
                      <Box display="flex" gap="0 14px">
                        <Box display="flex">
                          <label
                            style={{
                              width: '39px',
                              lineHeight: '24px',
                              height: '24px',
                              color: 'rgba(0, 0, 0, 0.87)',
                            }}
                          >
                            字号
                          </label>
                          <FormControl
                            variant="standard"
                            sx={{ width: '70px' }}
                          >
                            <Controller
                              render={(pr) => (
                                <SelectFieldCom
                                  pr={pr}
                                  typeList={fontSizeList}
                                  queryType={queryType}
                                />
                              )}
                              label=""
                              name="drawNumSize"
                              variant="standard"
                              control={control}
                            />
                          </FormControl>
                        </Box>
                        <Box display="flex">
                          <label
                            style={{
                              width: '39px',
                              lineHeight: '24px',
                              height: '24px',
                              color: 'rgba(0, 0, 0, 0.87)',
                            }}
                          >
                            颜色
                          </label>
                          <Box
                            sx={{
                              width: '100px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
                            }}
                          >
                            <Typography
                              sx={{
                                color: getValues('drawNumColor'),
                                lineHeight: '24px',
                                height: '24px',
                              }}
                            >
                              演示
                            </Typography>
                            <span
                              className="color-range"
                              onClick={() => {
                                queryType !== 'detail' &&
                                  setOpenColorModal(true);
                                queryType !== 'detail' &&
                                  setInputName('drawNumColor');
                              }}
                              style={{ lineHeight: '24px', height: '24px' }}
                            >
                              <span
                                className="circle"
                                style={{
                                  borderColor: getValues('drawNumColor'),
                                }}
                              >
                                <ColorLensIcon
                                  style={{ color: getValues('drawNumColor') }}
                                />
                              </span>
                            </span>
                          </Box>
                          <Controller
                            render={(pr) => (
                              <TextField
                                sx={{ display: 'none' }}
                                variant="standard"
                                id="outlined-multiline-static"
                                autoComplete="off"
                                label=""
                                value={pr.value ?? ''}
                              />
                            )}
                            control={control}
                            name="drawNumColor"
                          />
                        </Box>
                      </Box>
                      {queryType !== 'detail' && (
                        <Box
                          sx={{
                            fontWeight: 400,
                            fontSize: 16,
                            color: '#1565C0',
                            width: '86px',
                            textAlign: 'center',
                            cursor: 'pointer',
                          }}
                          onClick={() =>
                            resetStyle('drawNumSize', 'drawNumColor')
                          }
                        >
                          恢复默认
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box mb={2} mt={3} color="#212100" fontSize="12px">
                    轮播信息文字设置
                  </Box>
                  <Box className="set-color-font-wrap">
                    <Box display="flex" gap="0 42px" alignItems="center">
                      <Box display="flex" gap="0 14px">
                        <Box display="flex">
                          <label
                            style={{
                              width: '39px',
                              lineHeight: '24px',
                              height: '24px',
                              color: 'rgba(0, 0, 0, 0.87)',
                            }}
                          >
                            字号
                          </label>
                          <FormControl
                            variant="standard"
                            sx={{ width: '70px' }}
                          >
                            <Controller
                              render={(pr) => (
                                <SelectFieldCom
                                  pr={pr}
                                  typeList={fontSizeList}
                                  queryType={queryType}
                                />
                              )}
                              label=""
                              name="rotationFontSize"
                              variant="standard"
                              control={control}
                            />
                          </FormControl>
                        </Box>
                        <Box display="flex">
                          <label
                            style={{
                              width: '39px',
                              lineHeight: '24px',
                              height: '24px',
                              color: 'rgba(0, 0, 0, 0.87)',
                            }}
                          >
                            颜色
                          </label>
                          <Box
                            sx={{
                              width: '100px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
                            }}
                          >
                            <Typography
                              sx={{
                                color: getValues('rotationFontColor'),
                                lineHeight: '24px',
                                height: '24px',
                              }}
                            >
                              演示
                            </Typography>
                            <span
                              className="color-range"
                              onClick={() => {
                                queryType !== 'detail' &&
                                  setOpenColorModal(true);
                                queryType !== 'detail' &&
                                  setInputName('rotationFontColor');
                              }}
                              style={{ lineHeight: '24px', height: '24px' }}
                            >
                              <span
                                className="circle"
                                style={{
                                  borderColor: getValues('rotationFontColor'),
                                }}
                              >
                                <ColorLensIcon
                                  style={{
                                    color: getValues('rotationFontColor'),
                                  }}
                                />
                              </span>
                            </span>
                          </Box>
                          <Controller
                            render={(pr) => (
                              <TextField
                                sx={{ display: 'none' }}
                                variant="standard"
                                id="outlined-multiline-static"
                                autoComplete="off"
                                label=""
                                value={pr.value ?? ''}
                              />
                            )}
                            control={control}
                            name="rotationFontColor"
                          />
                        </Box>
                      </Box>
                      {queryType !== 'detail' && (
                        <Box
                          sx={{
                            fontWeight: 400,
                            fontSize: 16,
                            color: '#1565C0',
                            width: '86px',
                            textAlign: 'center',
                            cursor: 'pointer',
                          }}
                          onClick={() =>
                            resetStyle('rotationFontSize', 'rotationFontColor')
                          }
                        >
                          恢复默认
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
                <Box display="none">
                  <Controller
                    render={(pr) => (
                      <TextField
                        variant="standard"
                        id="outlined-multiline-static"
                        autoComplete="off"
                        label=""
                        value={pr.value ?? ''}
                        error={Boolean(errors.backgroundPic)}
                      />
                    )}
                    control={control}
                    name="backgroundPic"
                    rules={{
                      required: true,
                    }}
                  />
                  <Controller
                    render={(pr) => (
                      <TextField
                        variant="standard"
                        id="outlined-multiline-static"
                        autoComplete="off"
                        label=""
                        value={pr.value ?? ''}
                        error={Boolean(errors.wheelPic)}
                      />
                    )}
                    control={control}
                    name="wheelPic"
                    rules={{
                      required: true,
                    }}
                  />
                  <Controller
                    render={(pr) => (
                      <TextField
                        variant="standard"
                        id="outlined-multiline-static"
                        autoComplete="off"
                        label=""
                        value={pr.value ?? ''}
                        error={Boolean(errors.wheelBackgroundPic)}
                      />
                    )}
                    control={control}
                    name="wheelBackgroundPic"
                    rules={{
                      required: true,
                    }}
                  />
                </Box>
                <Button
                  type="submit"
                  ref={submitRef}
                  style={{ display: 'none' }}
                />
              </Box>
              {/*right*/}
              <Box width="567px" height="567px" mt={4} ref={pieWrapRef}></Box>
            </Box>
          </form>
          <ModalML
            open={openColorModal}
            setOpen={setOpenColorModal}
            onClose={() => {
              setOpenColorModal(false);
            }}
            title={'选择颜色'}
          >
            <ModalStyled type={'colorSelect'}>
              <Box>
                <SketchPicker
                  color={color}
                  onChange={
                    (e) => {
                      console.log(e, '====');
                      setColor(e.hex);
                    }
                    // handleColorChange
                  }
                />
              </Box>
              <Box className="button-group" mt={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  className="cancel"
                  startIcon={
                    <CloseIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  onClick={() => {
                    setOpenColorModal(false);
                  }}
                >
                  取消
                </Button>

                <Button
                  variant="contained"
                  type="submit"
                  className="search"
                  onClick={() => {
                    setValue(inputName, color);
                    setOpenColorModal(false);
                  }}
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  确 认
                </Button>
              </Box>
            </ModalStyled>
          </ModalML>
          <SimpleDialog
            open={dOpen}
            onClose={handleClose}
            imgSrc={
              Array.isArray(previewImages) && previewImages.length > 0
                ? previewImages[0].data_url
                : ''
            }
          />
        </Box>
      </StepsThreeMLStyled>
    );
  },
);
